import axios from "axios";
import apiURL from "./urls";
import toast from 'react-hot-toast';

function CustomException(message, metadata) {
  const error = new Error(message);
  error.metadata = metadata;
  return error;
}

// All backend communication

const apiGetUserSettings = async () => {
  try {
    const { data } = await axios({
      method: "get",
      url: apiURL.userSettings,
      timeout: 7000,
    });
    return data;
  } catch (e) {
    toast.error("Error fetching user settings");
    throw CustomException("Error fetching user settings", e);
  }
};

const apiPostUserSettings = async (payload) => {
  try {
    await axios({
      method: "post",
      url: apiURL.userSettings,
      timeout: 7000,
      data: { data: payload },
    });
  } catch (e) {
    toast.error("Error posting user settings");
    throw CustomException("Error posting user settings", e);
  }
};

// QBO Authentication
const apiGetQBOAuthUri = async (payload) => {
  try {
    const { data } = await axios({
      method: "get",
      url: apiURL.quickbooksAuth,
      timeout: 7000,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      params: {
        environment: payload.environment,
        dbCompanyID: payload.companyId
      }
    });
    return data;
  } catch (e) {
    toast.error("Error fetching Intuit Quickbooks Auth URI");
    throw CustomException("Error fetching Intuit Quickbooks Auth URI", e);
  }
};

// Get companyId using userId and companyName in source-select page. verify link
const apiGetCompanyId = async (payload) => {
  try {
    const { data } = await axios({
      method: "post",
      url: apiURL.verifyCompanyLink,
      timeout: 50000,
      data: payload,
    });
    return data;
  } catch (e) {
    toast.error("Error fetching company id");
    throw CustomException("Error fetching company id", e);
  }
};

// Save Company Data for Excel
const apiSaveCompanyData = async (payload) => {
  try {
    await axios({
      method: "put",
      url: apiURL.saveCompanyData,
      timeout: 20000,
      data: payload,
    });
    // toast.success("Your company data is saved successfully.");
    return;
  } catch (e) {
    toast.error("Error saving company data");
    throw CustomException("Error saving company data", e);
  }
};

// Get list of all companies
const apiGetCompanies = async () => {
  try {
    const { data } = await axios({
      method: "get",
      url: apiURL.getCompanies,
      timeout: 7000,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    });
    return data;
  } catch (e) {
    throw CustomException("Error fetching Companies", e);
  }
};

// Get company profit loss
const apiGetCompanyProfitLoss = async (payload) => {
  let payloadData = { ...payload, type: "get_accounting_profit_loss" };
  try {
    const { data } = await axios({
      method: "post",
      url: apiURL.getCompanyData,
      timeout: 50000,
      data: payloadData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    });
    return data;
  } catch (e) {
    throw CustomException("Error fetching profit loss", e);
  }
};

// Get company Balance Sheet
const apiGetCompanyBalanceSheet = async (payload) => {
  let payloadData = { ...payload, type: "get_accounting_balance_sheet" };
  try {
    const { data } = await axios({
      method: "post",
      url: apiURL.getCompanyData,
      timeout: 50000,
      data: payloadData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    });
    return data;
  } catch (e) {
    throw CustomException("Error fetching balance sheet", e);
  }
};

//fetch project list
const apiGetProjectList = async (payload) => {
  try {
    const { data } = await axios({
      method: "get",
      url: apiURL.projectList,
      timeout: 20000,
      params: payload,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    });
    return data;
  } catch (e) {
    toast.error("Error fetching the project list");
    if (e.message === "Network Error" || e.response.status === 401 || e.response.status === 403) {
      localStorage.removeItem("token");
      // localStorage.clear();
      if (!e.config.url.includes("//")) {
        window.location = "/";
      }
    }
    throw CustomException("Error fetching the project list", e);
  }
};

//fetch the selected model data
const apiGetProjectData = async (payload) => {
  try {
    const { data } = await axios({
      method: "get",
      url: apiURL.projectData,
      timeout: 20000,
      params: payload,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    });
    return data;
  } catch (e) {
    console.log(e)
    toast.error("Error fetching the project data");
    if (e.message === "Network Error" || e.response.status === 401 || e.response.status === 403) {
      localStorage.removeItem("token");
      // localStorage.clear();
      if (!e.config.url.includes("//")) {
        window.location = "/";
      }
    }
    throw CustomException("Error fetching the project data", e);
  }
};

//save the current model
const apiSaveProjectData = async (payload) => {
  try {
    const { data } = await axios({
      method: "post",
      url: apiURL.projectData,
      timeout: 20000,
      data: { projectData: payload },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    });
    return data;
  } catch (e) {
    toast.error("Error saving the project data");
    if (e.message === "Network Error" || e.response.status === 401 || e.response.status === 403) {
      localStorage.removeItem("token");
      // localStorage.clear();
      if (!e.config.url.includes("//")) {
        window.location = "/";
      }
    }
    throw CustomException("Error saving the project data", e);
  }
};

//delete the current model
const apiDeleteProjectData = async (payload) => {
  try {
    const response = await axios({
      method: "delete",
      url: apiURL.projectData,
      timeout: 20000,
      params: payload,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    });
  } catch (e) {
    console.log(e)
    toast.error("Error deleting the project");
    if (e.message === "Network Error" || e.response.status === 401 || e.response.status === 403) {
      localStorage.removeItem("token");
      // localStorage.clear();
      if (!e.config.url.includes("//")) {
        window.location = "/";
      }
    }
    throw CustomException("Error deleting the project", e);
  }
};

//panda doc backend
const apiCreatePandaDoc = async (payload) => {
  if(payload.type === "Generate") { 
    try {
      //create a temp document
      const createResponse = await axios({
        method: "post",
        url: apiURL.createPandaDoc,
        timeout: 70000,
        data: { ...payload, source: "Company" },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      });
      return createResponse?.data?.id;
    } catch (e) {
      console.log(e)
      throw CustomException("Error generating a document using PandaDoc API", e);
    }
  }
  else if(payload.type === "Download") {
    try {
      //download the document
      const downloadResponse = await axios({
        method: "post",
        url: apiURL.createPandaDoc,
        timeout: 200000,
        responseType: 'blob',
        data: { ...payload, source: "Company" },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      });
  
      //download a PDF file
      let url = URL.createObjectURL(new Blob([downloadResponse.data]));
      let link = document.createElement('a');
      link.href = url;
      link.download = 'BVA report.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("PDF report downloaded successfully.");
    } catch (e) {
      console.log(e)
      throw CustomException("Error downloading a document using PandaDoc API", e);
    }
  }
  else if(payload.type === "DOCX") {
    try {

      // download the document
      const downloadResponse = await axios({
        method: "post",
        url: apiURL.createPandaDoc,
        timeout: 200000,
        data: { ...payload, source: "Company" },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      });

      let link = document.createElement('a');
      link.href = downloadResponse.data?.docx_items[0].url;
      link.download = 'BVA report.docx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("DOCX report downloaded successfully.");
    } catch (e) {
      toast.error("Failed. Try again, please.");
      console.log(e)
      throw CustomException("Error downloading a document using PandaDoc API", e);
    }
  }
}

// Get company Statistics Result
const apiGetCompanyStatisticsResult = async (payload) => {
  let payloadData = { ...payload };
  try {
    const { data } = await axios({
      method: "post",
      url: apiURL.getCompanyStatistics,
      timeout: 50000,
      data: payloadData,
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    });
    return data;
  } catch (e) {
    throw CustomException("Error fetching company statistics result ", e);
  }
};

// Solve Goal Seek
const apiSolveGoalSeek = async (payload) => {
  let payloadData = { ...payload, type: "goal_seek" };
  try {
    const { data } = await axios({
      method: "post",
      url: apiURL.financialCalculations,
      timeout: 120000,
      data: payloadData,
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    });
    return data;
  } catch (e) {
    throw CustomException("Error soliving goal seek", e);
  }
};

// Solve Goal Seek
const apiPriceMatrix = async (payload) => {
  let payloadData = { ...payload, type: "price_matrix" };
  try {
    const { data } = await axios({
      method: "post",
      url: apiURL.financialCalculations,
      timeout: 120000,
      data: payloadData,
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    });
    return data;
  } catch (e) {
    throw CustomException("Error soliving goal seek", e);
  }
};

//GPT integration
const apiGetGPTCategorySelection = async (payload) => {

  try {
    const { data } = await axios({
      method: "post",
      url: apiURL.gptCategory,
      timeout: 50000,
      data: { data: payload },
    });

    return data;
  } catch (e) {
    toast.error("Error fetching category from GPT");
    throw CustomException("Error fetching category from GPT", e);
  }
};

const apiGetGPTNoteGeneration = async (payload) => {

  try {
    const { data } = await axios({
      method: "post",
      url: apiURL.gptNote,
      timeout: 50000,
      data: { data: payload },
    });

    return data;
  } catch (e) {
    toast.error("Error fetching analyst note from GPT");
    throw CustomException("Error fetching analyst note from GPT", e);
  }
};

const apiGetGPTSearchRate = async (payload) => {
  
  try {
    const { data } = await axios({
      method: "post",
      url: apiURL.gptSearchRate,
      timeout: 50000,
      data: { data: payload },
    });

    return data;
  } catch (e) {
    toast.error("Error fetching search result from GPT");
    throw CustomException("Error fetching search result from GPT", e);
  }
};

const apiGetGPTSearchCompany = async (payload) => {
  
  try {
    const { data } = await axios({
      method: "post",
      url: apiURL.gptSearchCompany,
      timeout: 100000,
      data: { data: payload },
    });

    return JSON.parse(data);
  } catch (e) {
    toast.error("Error fetching search result from GPT");
    throw CustomException("Error fetching search result from GPT", e);
  }
};

const apiGetGPTSearchReport = async (payload) => {
  
  try {
    const { data } = await axios({
      method: "post",
      url: apiURL.gptSearchReport,
      timeout: 10000000,
      data: { data: payload },
    });

    return data;
  } catch (e) {
    toast.error("Error fetching search result from GPT");
    throw CustomException("Error fetching search result from GPT", e);
  }
};

const apiPostEmail = async (payload) => {
  
  try {
    const response = await axios({
      method: "post",
      url: apiURL.sendEmail,
      timeout: 7000,
      data: payload,
    });

    return response.data.message;
  } catch (e) {
    toast.error("Error sending email");
    throw CustomException("Error sending email", e);
  }
};

export {
  apiGetUserSettings,
  apiPostUserSettings,
  apiGetQBOAuthUri,
  apiGetCompanyId,
  apiSaveCompanyData,
  apiGetCompanies,
  apiGetCompanyProfitLoss,
  apiGetCompanyBalanceSheet,
  apiGetProjectList,
  apiGetProjectData,
  apiSaveProjectData,
  apiDeleteProjectData,
  apiCreatePandaDoc,
  apiGetCompanyStatisticsResult,
  apiSolveGoalSeek,
  apiPriceMatrix,
  apiGetGPTCategorySelection,
  apiGetGPTNoteGeneration,
  apiGetGPTSearchRate,
  apiGetGPTSearchCompany,
  apiGetGPTSearchReport,
  apiPostEmail
};
